import { useI18n, SUPPORTED_LANGS } from "../../i18n";

export const LanguageSwitcher = ({ size = "sm" }) => {
  const { lang, setLang, t } = useI18n();
  return (
    <div role="group" aria-label={t("nav.ariaChangeLang")} className="lang-switch" data-testid="language-switcher">
      {SUPPORTED_LANGS.map((l, i) => (
        <span key={l} className="flex items-center">
          {i > 0 && <span className="lang-sep" aria-hidden="true">|</span>}
          <button
            type="button"
            onClick={() => setLang(l)}
            aria-label={`${t("nav.ariaChangeLang")} — ${l.toUpperCase()}`}
            aria-pressed={lang === l}
            className={`lang-btn ${size === "lg" ? "lang-btn-lg" : ""} ${lang === l ? "is-active" : ""}`}
            data-testid={`lang-switch-${l}`}
          >
            {l.toUpperCase()}
          </button>
        </span>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
